/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

/**
 * A simple regex to validate emails.
 *
 * This regex ensures that:
 * - The email contains exactly one "@".
 * - Neither the local nor domain parts include spaces or "@".
 * - The domain part contains at least one dot.
 *
 * **Note:** This heuristic is not fully RFC-compliant but works well for most use cases.
 *
 * @type {RegExp}
 */
export const emailRegexp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Validates a string as an email address.
 *
 * @param {string} value - The string to validate.
 * @returns {boolean} True if the value is a valid email; otherwise, false.
 *
 * @example
 *
 * isEmail('me@example.com');
 * // -> true
 *
 * isEmail('a.nonymous@example.com');
 * // -> true
 *
 * isEmail('name+tag@example.com');
 * // -> true
 *
 * isEmail('spaces are allowed@example.com');
 * // -> false
 *
 * isEmail("!#$%&'+-/=.?^`{|}~@[1.0.0.127]");
 * // -> true
 *
 * isEmail("!#$%&'+-/=.?^`{|}~@[IPv6:0123:4567:89AB:CDEF:0123:4567:89AB:CDEF]");
 * // -> false
 */
export const isEmail = (value) => {
  if (typeof value !== 'string') {
    throw new TypeError('Expected a string to validate; instead got ' + typeof value);
  }

  return emailRegexp.test(value);
};
